import { z } from 'zod';
import { ClientDataType, Combinator } from 'modules/queryBuilder/types';
import { transformInBetweenDates } from 'modules/queryBuilder/schemas/utils';
import { useSegmentationConditionSchema } from './useSegmentationConditionSchema';

export const useSegmentationRequirementSchema = () => {
  const segmentationConditionSchema = useSegmentationConditionSchema();
  return z
    .object({
      dataType: z.nativeEnum(ClientDataType),
      maxMatch: z.number().max(999).optional(),
      minMatch: z.number().min(1).optional(),
      searchCombo: z.object({
        combinator: z.nativeEnum(Combinator),
        searchQueries: z.array(segmentationConditionSchema),
      }),
    })
    .transform(transformInBetweenDates);
};
